// extracted by mini-css-extract-plugin
export default {"wrapper":"OD-z","viewport":"PD-z","container":"QD-z","slide":"RD-z"};